import { useTheme, createTheme } from '@mui/material';

/** Design-system fields (`@sm-dashboard/ui-components`) — keep parent theme, skip legacy form chrome. */
const FormProviderTheme = () => {
  const theme = useTheme();

  const formTheme = createTheme({
    ...theme,
    components: {
      ...theme.components,
      MuiGrid: {
        styleOverrides: {
          container: ({ ownerState }) => {
            return {
              alignItems: 'end',
              [theme.breakpoints.down('md')]: {
                '&>.MuiGrid-item': {
                  paddingTop: !isNaN(Number(ownerState.rowSpacing))
                    ? `${Number(ownerState.rowSpacing) * 8 + 10}px`
                    : '0px'
                }
              }
            };
          }
        }
      }
    }
  });
  return formTheme;
};

export default FormProviderTheme;
